import { Col, message, Modal, Radio, Select } from 'antd';
import FormItem from 'antd/lib/form/FormItem';
import TextArea from 'antd/lib/input/TextArea';
import { gql } from 'apollo-boost';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { DateRange } from 'src/types/base';

import {
  USER_CONTACT_RECORD_FEEDBACK_LIST,
  USER_CONTACT_RECORD_INTENT_NAME,
  USER_CONTACT_RECORD_STAGE_LIST,
  UserContactRecordFeedback,
  UserContactRecordIntent,
  UserContactRecordStage,
  UserContactRecordType,
} from '../user/Users';
import { groupDetailQuery } from './GroupDetail';

interface Props {
  currentUserId?: number;
  isAddWeChatRecord: boolean;
  isAddRecordModalDisplay: boolean;
  closeAddRecordModal: () => void;
  isCallSuccess?: boolean;
  onIsCallSuccessChange: Function;
  onIntentChange: Function;
  onRemarkChange: Function;
  onRecordFeedbackChange: Function;
  intent?: UserContactRecordIntent;
  remark?: string;
  feedback?: UserContactRecordFeedback;
  submitAddFeedback: Function;
  groupId?: number;
  activityId: string;
  dateRange: DateRange;
}

const createUserContactRecordMutation = gql`
  mutation createUserContactRecord(
    $userId: ID!
    $type: Int!
    $intent: Int!
    $remark: String!
    $feedback: Int!
    $isSuccess: Boolean
  ) {
    createUserContactRecord(
      userId: $userId
      type: $type
      intent: $intent
      remark: $remark
      feedback: $feedback
      isSuccess: $isSuccess
    ) {
      id
    }
  }
`;

interface State {
  currentStage: UserContactRecordStage;
}

export class AddRecord extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      currentStage: UserContactRecordStage.ALL_STAGES,
    };
  }

  getRecordType() {
    const { isAddWeChatRecord } = this.props;
    let type = UserContactRecordType.WECHAT;
    if (!isAddWeChatRecord) {
      type = UserContactRecordType.PHONE_CALL;
    }
    return type;
  }

  onCurrentStageChange = (value: UserContactRecordStage) => {
    this.setState({
      currentStage: value,
    });
  };

  render() {
    const {
      currentUserId,
      onIsCallSuccessChange,
      onIntentChange,
      onRecordFeedbackChange,
      onRemarkChange,
      intent,
      remark,
      isAddRecordModalDisplay,
      isAddWeChatRecord,
      closeAddRecordModal,
      isCallSuccess,
      feedback,
      submitAddFeedback,
      activityId,
      dateRange,
      groupId,
    } = this.props;
    const { currentStage } = this.state;
    const getRecordType = this.getRecordType();

    return (
      <Mutation
        mutation={createUserContactRecordMutation}
        variables={{
          intent,
          remark,
          feedback,
          isSuccess: isCallSuccess,
          userId: currentUserId,
          type: getRecordType,
        }}
        refetchQueries={[
          {
            query: groupDetailQuery,
            variables: {
              activityId,
              dateRange,
              groupId,
              miniGameName: 'admission-quiz',
            },
          },
        ]}
      >
        {createUserContactRecord => {
          return (
            <Modal
              closable={false}
              visible={isAddRecordModalDisplay}
              onOk={async () => {
                try {
                  const completed = submitAddFeedback();
                  if (completed) {
                    await createUserContactRecord();
                    message.success('新增成功');
                  }
                } catch (e) {
                  message.error(e.message);
                }
              }}
              onCancel={() => closeAddRecordModal()}
            >
              {!isAddWeChatRecord && (
                <FormItem label={`接通情况`}>
                  <Radio.Group onChange={e => onIsCallSuccessChange(e)} value={isCallSuccess}>
                    <Radio value>接通</Radio>
                    <Radio value={false}>未接通</Radio>
                  </Radio.Group>
                </FormItem>
              )}
              <FormItem label={`意向度`}>
                <Radio.Group onChange={e => onIntentChange(e)} value={intent}>
                  {Object.keys(USER_CONTACT_RECORD_INTENT_NAME).map(status => {
                    return (
                      <Radio key={status} value={status}>
                        {USER_CONTACT_RECORD_INTENT_NAME[status]}
                      </Radio>
                    );
                  })}
                </Radio.Group>
              </FormItem>

              <FormItem label={`用户反馈`}>
                <Col xs={24} md={24} lg={8} xl={16} xxl={16}>
                  <Select
                    placeholder="请选择"
                    style={{ width: '100%' }}
                    allowClear
                    onChange={this.onCurrentStageChange}
                  >
                    {Object.keys(USER_CONTACT_RECORD_STAGE_LIST).map(stage => {
                      {
                        return (
                          <Select.Option key={stage} value={stage}>
                            {USER_CONTACT_RECORD_STAGE_LIST[stage]}
                          </Select.Option>
                        );
                      }
                    })}
                  </Select>
                  <Select
                    placeholder="请选择"
                    style={{ width: '100%' }}
                    allowClear
                    onChange={value => onRecordFeedbackChange(value)}
                  >
                    {Object.keys(USER_CONTACT_RECORD_FEEDBACK_LIST[currentStage]).map(status => {
                      {
                        return (
                          <Select.Option key={status} value={status}>
                            {USER_CONTACT_RECORD_FEEDBACK_LIST[currentStage][status]}
                          </Select.Option>
                        );
                      }
                    })}
                  </Select>
                </Col>
              </FormItem>
              <FormItem label={`跟进记录`}>
                <TextArea
                  placeholder="请输入..."
                  autosize={{ minRows: 5 }}
                  value={remark}
                  onChange={e => onRemarkChange(e)}
                  style={{ marginBottom: 26 }}
                />
              </FormItem>
            </Modal>
          );
        }}
      </Mutation>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/group/AddRecord.tsx